import { OnMatchRecord, RecordResponse, ChatBase } from 'rcx_adapter/src/index';
import { updateSessionData } from 'rcx_adapter/src/rules';

import { BaseModule } from './BaseModule';
import { ModuleBaseOption } from '../interfaces/module';
import { ruleConfigsForDigital } from '../rules/ServiceNowRuleConfigs';

class OnDigitalMatch extends BaseModule<ModuleBaseOption> {
    cacheMap = new Map<string, any>();

    public start(): void {
        if (this.getIsInit()) {
            this.listenFromRCX();
        }
    }
    public listenFromRCX() {
        this.mRCXAdapter!.onMatchingRecords((data: OnMatchRecord) => {
            if (data.type === 'Digital') {
                const chatBaseData = data.params as ChatBase;
                updateSessionData(chatBaseData, data.type, ruleConfigsForDigital);
                return this.onMatchingRecords(data.params as ChatBase);
            }
        });
    }
    public async onMatchingRecords(data: ChatBase): Promise<RecordResponse> {
        const matchingRules = data.sessionData?.cx?.crm?.matchingRules;

        const records: any[] = [];
        for (const { crmEntityType, crmEntityIdName, crmEntityValue } of matchingRules!) {
            const response = await this.mServiceNowAdapter!.getStandMatch(
                crmEntityValue as string,
                crmEntityIdName,
                crmEntityType
            );
            if (Array.isArray(response) && response.length > 0) {
                records.push(...response);
            }
        }
        return {
            records,
        };
    }
}

export default new OnDigitalMatch();
